import http from "./public";

/**
 * @description 查询CDN验签url
 */
export const queryHelpFileUrlMd5 = (params) => {
  //公司详情
  return http(`/api/web/project/queryHelpFileUrlMd5`, params);
};
